import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Accueil = () => {
  const [token, setToken] = useState("");
  const navigation = useNavigate();

  const navigate = () => {
    if (token.trim()) navigation(`/${token}/home`);
  };

  return (
    <div className="login-wrapper">
      <div style={{
        background: '#fff',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
        padding: '48px 40px',
        width: '100%',
        maxWidth: '420px',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '52px', lineHeight: 1, marginBottom: '14px' }}>⚡</div>
          <h4 style={{ fontWeight: 700, color: '#1e3a5f', margin: '0 0 6px' }}>
            SLife Gateway Admin
          </h4>
          <p style={{ color: '#6c757d', fontSize: '13px', margin: 0 }}>
            Paiement Mobile Money Madagascar
          </p>
        </div>

        <Form onSubmit={(e) => { e.preventDefault(); navigate(); }}>
          <Form.Group className="mb-3">
            <Form.Label style={{ fontWeight: 600, fontSize: '12px', color: '#495057', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Token d'accès
            </Form.Label>
            <Form.Control
              type="password"
              placeholder="Entrez votre token..."
              value={token}
              onChange={(e) => setToken(e.target.value)}
              style={{ padding: '11px 14px', borderRadius: '8px', fontSize: '14px', border: '1.5px solid #dee2e6' }}
              autoFocus
            />
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="w-100"
            style={{
              padding: '11px',
              borderRadius: '8px',
              fontWeight: 600,
              fontSize: '14px',
              background: 'linear-gradient(135deg, #1e3a5f 0%, #0d6efd 100%)',
              border: 'none',
              boxShadow: '0 4px 12px rgba(13,110,253,0.35)',
            }}
          >
            Accéder au tableau de bord →
          </Button>
        </Form>

        <div style={{
          marginTop: '20px',
          background: '#fff8e1',
          border: '1px solid #f59f00',
          borderRadius: '8px',
          padding: '12px 14px',
          fontSize: '12px',
          color: '#5f3e00',
          lineHeight: 1.55,
        }}>
          <strong>🔒 Conseil de sécurité —</strong> Pour protéger votre token, accédez toujours à cette page depuis une <strong>fenêtre de navigation privée</strong> (
          <span style={{ fontFamily: 'monospace', background: 'rgba(0,0,0,0.07)', padding: '1px 4px', borderRadius: '3px' }}>Ctrl+Maj+N</span>
          {' '}/ <span style={{ fontFamily: 'monospace', background: 'rgba(0,0,0,0.07)', padding: '1px 4px', borderRadius: '3px' }}>⌘+Maj+N</span>).
          Ainsi le navigateur ne conservera ni votre token dans l'historique des URLs, ni aucune trace de votre session.
        </div>
      </div>
    </div>
  );
};

export default Accueil;
